<template>

    <div>

        <div v-if="!smartphone">

            <!--<div class="border-b transform border-theme-level2 flex flex-col px-6 transition-all duration-200" :class="{ 'hideHelper': !this.$root.shared.helpersVisible, 'overflow-hidden': !this.$root.shared.helpersVisible }" style="z-index: 9999;">-->
            <div id="helpersContainer" class="border-b transform border-theme-level2 flex flex-col transition-all duration-200" :class="{ 'hideHelper': !this.$root.shared.helpersVisible, 'overflow-hidden': !this.$root.shared.helpersVisible }" style="z-index: 9999;">

                <!--<div class="flex flex-col mx-auto" style="min-width: 600px; max-width: 850px;">-->
                <div class="flex flex-col ml-6" style="min-width: 600px; max-width: 850px;">

                    <p class="text-sm text-theme-discrete mb-2 mt-4">{{ translate('helper-intro') }}</p>

                    <!-- SUBCATS -->
                    <div>

                        <div class="flex flex-row items-center mb-6 mt-4">
                            <label for="fld-subcategories" class="w-32 text-theme-main self-start">{{ translate('helper-subcats') }}:</label>
                            <div class="w-4/5">
                                <ul id="fld-subcategories" class="flex flex-row flex-wrap">

                                    <li v-for="(subcategory, index) in subcategories" :key="subcategory.name">
                                        <!--suppress HtmlFormInputWithoutLabel -->
                                        <input type="checkbox" v-model="selectedSubCategories"
                                               :value="subcategory.id"
                                               class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                               :class="{ 'ml-4': index === 0 }"
                                               checked>
                                               <!--:class="{ 'ml-4': index === 0, 'opacity-25': unavailablesubcats.includes(subcategory.id) }"
                                               :disabled="!!unavailablesubcats.includes(subcategory.id)"-->

                                        <!--<span class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes(subcategory.id) }">{{ currentlocale==='es' ? subcategory.name : subcategory.name_en }}</span>-->
                                        <span class="ml-2 text-theme-discrete">{{ currentlocale==='es' ? subcategory.name : subcategory.name_en }}</span>
                                    </li>

                                    <li>
                                        <input type="checkbox" v-model="selectedSubCategories"
                                               :value="0"
                                               class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                               checked>
                                               <!--:disabled="!!unavailablesubcats.includes('0')"
                                               :class="{ 'opacity-25': unavailablesubcats.includes('0') }"-->

                                        <!--<span v-if="currentlocale==='es'" class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes('0') }">Sin Asignar</span>
                                        <span v-else class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes('0') }">Unassigned</span>-->
                                        <span v-if="currentlocale==='es'" class="ml-2 text-theme-discrete">Sin Asignar</span>
                                        <span v-else class="ml-2 text-theme-discrete">Unassigned</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <!-- END SUBCATS -->

                    <div class="flex flex-row">
                        <!-- COUNTRIES -->
                        <div class="w-1/2">

                            <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedCountriesArray) && selectedCountriesArray.length, 'mb-6': !(Array.isArray(selectedCountriesArray) && selectedCountriesArray.length) }">
                                <label for="fld-countries" class="text-theme-main mr-4">{{ translate("content-create-countries") }}:</label>
                                <div class="py-1 w-64">
                                    <v-select id="fld-countries"
                                              class="vselect bg-theme-level5 text-theme-main"
                                              :clearable="false" :placeholder="translate('content-create-open-countries')"
                                              :options="countriesList" @input="countrySelected"></v-select>
                                </div>
                            </div>

                            <div v-if="Array.isArray(selectedCountriesArray) && selectedCountriesArray.length" id="countries-radios-group" v-model="selectedCountriesArray" class="mb-2">
                                <div v-model="selectedCountriesArray" v-for="(country, index) in selectedCountriesArray" class="flex flex-row items-center mb-4">
                                    <div class="w-24 mr-4"></div>
                                    <div class="w-64 border-b border-theme-level2 text-theme-discrete mr-4">{{ country.label }}</div>
                                    <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCountryFromSelectedList(index)">delete</i>
                                </div>
                            </div>

                        </div>
                        <!-- END COUNTRIES -->

                        <!-- CORRESPONDENTS -->
                        <div class="w-1/2">

                            <div class="flex flex-row items-center" :class="{ 'mb-4': Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length, 'mb-6': !(Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length) }">
                                <label for="fld-persons" class="text-theme-main mr-4">{{ translate("playerview-correspondent") }}:</label>
                                <div class="py-1 w-64">
                                    <v-select id="fld-persons"
                                              class="vselect bg-theme-level5 text-theme-main"
                                              :clearable="false" :placeholder="translate('content-create-open-persons')"
                                              :options="correspondentsList" @input="correspondentSelected"></v-select>
                                </div>
                            </div>

                            <div v-if="Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length" id="radios-group" v-model="selectedCorrespondentsArray" class="mb-2">
                                <div v-model="selectedCorrespondentsArray" v-for="(correspondent, index) in selectedCorrespondentsArray" class="flex flex-row items-center mb-4">
                                    <div class="w-24 mr-4"></div>
                                    <div class="w-64 border-b border-theme-level2 text-theme-discrete mr-4">{{ correspondent.label }}</div>
                                    <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCorrespondentFromSelectedList(index)">delete</i>
                                </div>
                            </div>

                        </div>
                        <!-- END CORRESPONDENTS -->

                    </div>

                    <p class="text-sm text-theme-discrete mb-2 mt-2">{{ translate('helper-extra') }}</p>

                    <!-- TAGS -->
                    <div>

                        <div class="flex flex-row items-center mb-6">

                            <label for="fld-tags" class="relative w-24 text-theme-main self-start label-align-top">{{ translate("content-create-tags") }}:</label>

                            <vue-tags-input id="fld-tags"
                                            v-model="tag" :tags="selectedTags" :autocomplete-items="filteredItems"
                                            :add-only-from-autocomplete="true"
                                            @tags-changed="newTags => selectedTags = newTags"
                                            :placeholder="tagsPlaceholder"
                                            class="tags-input ml-4 border-b border-theme-level2 w-full flex-1 bg-theme-level5" />

                        </div>

                    </div>
                    <!-- END TAGS -->

                    <div class="flex flex-row items-center">
                        <button type="button" class="p-4 w-64 bg-theme-controls3 text-theme-control-label hover:bg-theme-controls1 rounded-lg cursor-pointer mb-6" @click="applyFilters">{{ translate('helper-apply-filters') }}</button>
                        <button type="button" class="ml-4 p-4 bg-theme-controls3 w-32 text-theme-control-label hover:bg-theme-controls1 rounded-lg cursor-pointer mb-6" @click="toggleDataIsVisible">{{ translate('close') }}</button>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="smartphone" class="overflow-hidden">

            <div class="border-b transform border-theme-level2 flex flex-col px-6 transition-all duration-200" :class="{ 'hideHelper': !this.$root.shared.helpersVisible, 'overflow-hidden': !this.$root.shared.helpersVisible }" style="z-index: 9999;">

                <div class="flex flex-col mx-auto w-full">

                    <p class="text-sm text-theme-muted mb-2 mt-4 leading-normal">{{ translate('helper-intro') }}</p>

                    <!-- SUBCATS -->
                    <div>

                        <div class="flex flex-col items-center mb-6 mt-4">
                            <label for="fld-subcategories" class="text-theme-main self-start mb-4">{{ translate('helper-subcats') }}:</label>
                            <div class="w-full">
                                <ul id="fld-subcategories" class="flex flex-row flex-wrap">

                                    <li v-for="(subcategory, index) in subcategories" :key="subcategory.name">
                                        <!--suppress HtmlFormInputWithoutLabel -->
                                        <input type="checkbox" v-model="selectedSubCategories"
                                               :value="subcategory.id"
                                               class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                               :class="{ 'ml-4': index === 0 }"
                                               checked>
                                        <!--:class="{ 'ml-4': index === 0, 'opacity-25': unavailablesubcats.includes(subcategory.id) }"
                                        :disabled="!!unavailablesubcats.includes(subcategory.id)"-->

                                        <!--<span class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes(subcategory.id) }">{{ currentlocale==='es' ? subcategory.name : subcategory.name_en }}</span>-->
                                        <span class="ml-2 text-theme-discrete">{{ currentlocale==='es' ? subcategory.name : subcategory.name_en }}</span>
                                    </li>

                                    <li>
                                        <input type="checkbox" v-model="selectedSubCategories"
                                               :value="0"
                                               class="form-checkbox h-5 w-5 text-theme-controls3 ml-4 mb-2 bg-theme-level5"
                                               checked>
                                        <!--:disabled="!!unavailablesubcats.includes('0')"
                                        :class="{ 'opacity-25': unavailablesubcats.includes('0') }"-->

                                        <!--<span v-if="currentlocale==='es'" class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes('0') }">Sin Asignar</span>
                                        <span v-else class="ml-2 text-theme-discrete" :class="{ 'opacity-25': unavailablesubcats.includes('0') }">Unassigned</span>-->
                                        <span v-if="currentlocale==='es'" class="ml-2 text-theme-discrete">Sin Asignar</span>
                                        <span v-else class="ml-2 text-theme-discrete">Unassigned</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <!-- END SUBCATS -->

                    <div class="flex flex-col">
                        <!-- COUNTRIES -->
                        <div class="w-full">

                            <div class="flex flex-col items-start" :class="{ 'mb-4': Array.isArray(selectedCountriesArray) && selectedCountriesArray.length, 'mb-6': !(Array.isArray(selectedCountriesArray) && selectedCountriesArray.length) }">
                                <label for="fld-countries" class="text-theme-main mr-4">{{ translate("content-create-countries") }}:</label>
                                <div class="py-1 w-64">
                                    <v-select id="fld-countries"
                                              class="vselect bg-theme-level5 text-theme-main"
                                              :clearable="false" :placeholder="translate('content-create-open-countries')"
                                              :options="countriesList" @input="countrySelected"></v-select>
                                </div>
                            </div>

                            <div v-if="Array.isArray(selectedCountriesArray) && selectedCountriesArray.length" id="countries-radios-group" v-model="selectedCountriesArray" class="mb-2">
                                <div v-model="selectedCountriesArray" v-for="(country, index) in selectedCountriesArray" class="flex flex-row items-center mb-4">
                                    <div class="w-24 mr-4"></div>
                                    <div class="w-64 border-b border-theme-level2 text-theme-discrete mr-4">{{ country.label }}</div>
                                    <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCountryFromSelectedList(index)">delete</i>
                                </div>
                            </div>

                        </div>
                        <!-- END COUNTRIES -->

                        <!-- CORRESPONDENTS -->
                        <div class="w-full">

                            <div class="flex flex-col items-start" :class="{ 'mb-4': Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length, 'mb-6': !(Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length) }">
                                <label for="fld-persons" class="text-theme-main mr-4">{{ translate("playerview-correspondent") }}:</label>
                                <div class="py-1 w-64">
                                    <v-select id="fld-persons"
                                              class="vselect bg-theme-level5 text-theme-main"
                                              :clearable="false" :placeholder="translate('content-create-open-persons')"
                                              :options="correspondentsList" @input="correspondentSelected"></v-select>
                                </div>
                            </div>

                            <div v-if="Array.isArray(selectedCorrespondentsArray) && selectedCorrespondentsArray.length" id="radios-group" v-model="selectedCorrespondentsArray" class="mb-2">
                                <div v-model="selectedCorrespondentsArray" v-for="(correspondent, index) in selectedCorrespondentsArray" class="flex flex-row items-center mb-4">
                                    <div class="w-24 mr-4"></div>
                                    <div class="w-64 border-b border-theme-level2 text-theme-discrete mr-4">{{ correspondent.label }}</div>
                                    <i class="material-icons ml-2 mr-4 cursor-pointer w-6 h-6 text-theme-muted hover:text-theme-main" @click="removeCorrespondentFromSelectedList(index)">delete</i>
                                </div>
                            </div>

                        </div>
                        <!-- END CORRESPONDENTS -->

                    </div>

                    <p class="text-sm text-theme-main mb-2 mt-2 leading-normal">{{ translate('helper-extra') }}</p>

                    <!-- TAGS -->
                    <div>

                        <div class="flex flex-col items-start mb-6">

                            <label for="fld-tags" class="relative w-24 text-theme-main self-start label-align-top mb-6">{{ translate("content-create-tags") }}:</label>

                            <vue-tags-input id="fld-tags"
                                            v-model="tag" :tags="selectedTags" :autocomplete-items="filteredItems"
                                            :add-only-from-autocomplete="true"
                                            @tags-changed="newTags => selectedTags = newTags"
                                            :placeholder="tagsPlaceholder"
                                            class="tags-input ml-4 border-b border-theme-level2 w-full flex-1 bg-theme-level5" />

                        </div>

                    </div>
                    <!-- END TAGS -->

                    <button type="button" class="p-4 bg-theme-controls3 text-theme-control-label hover:bg-theme-controls1 rounded-lg cursor-pointer mb-6" @click="applyFilters">{{ translate('helper-apply-filters') }}</button>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

    import { isMobileOnly } from 'mobile-device-detect';
    import { isTablet } from 'mobile-device-detect';

    import vSelect from 'vue-select';
    import VueTagsInput from '@johmun/vue-tags-input';

    import 'vue-select/dist/vue-select.css';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {
            VueTagsInput,
            vSelect
        },


        data() {
            return {

                subcategories: '',
                tag: '',

                selectedSubCategories: [],
                selectedCountriesArray: [],
                selectedTags: [],
                selectedCorrespondentsArray: [],

                tags: [],
                countries: [],
                correspondents: [],

                smartphone: isMobileOnly,
                tabletDevice: isTablet,

            }
        },

        props: [

            'currentlocale',
            'categoryid',
            'titlees',
            'titleen',

            'selectedsubcats',
            'unavailablesubcats',
            'selectedcountries',
            'selectedcorrespondents',
            'selectedtags'

        ],

        computed: {

            tagsPlaceholder() {

                return this.translate('helper-tags-placeholder');

            },

            countriesList() {
                if(this.currentlocale==='es') {
                    return this.countries.map(country => {
                        return {label: country.name, id: country.id}
                    });
                } else {
                    return this.countries.map(country => {
                        return {label: country.name_en, id: country.id}
                    });
                }
            },

            correspondentsList() {
                return this.correspondents.map(correspondent => { return { label: correspondent.name, id: correspondent.id, correspondent: correspondent.is_valid_correspondent } });
            },

            autocompleteItems() {

                let tmp = [];

                this.tags.forEach(data => {
                    tmp.push({'text': data.name});
                })

                return tmp;

            },

            autocompleteItems_en() {

                let tmp = [];

                this.tags.forEach(data => {
                    tmp.push({'text': data.name_en});
                })

                return tmp;

            },

            filteredItems() {
                if(this.currentlocale==='es') {
                    return this.autocompleteItems.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                } else {
                    return this.autocompleteItems_en.filter(i => {
                        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                    });
                }
            },

            incomingSubCategories() {

                /*let theSubCats = this.selectedsubcats.toJSON();*/
                let incomingSubCatArray = []
                /*theSubCats.forEach(tag => {
                    incomingSubCatArray.push(tag.id);
                });*/
                incomingSubCatArray = this.selectedsubcats.split(',');

                return incomingSubCatArray;

            },

            incomingCountries() {

                if(this.currentlocale==='es') {
                    return JSON.parse(this.selectedcountries).map(country => {
                        return {id: country.id, label: country.name}
                    });
                } else {
                    return JSON.parse(this.selectedcountries).map(country => {
                        return {id: country.id, label: country.name_en}
                    });
                }

            },

            incomingCorrespondents() {

                return JSON.parse(this.selectedcorrespondents).map(correspondent => { return { id: correspondent.id, label: correspondent.name} });

            },

            incomingTags() {

                if(this.currentlocale==='es') {
                    return JSON.parse(this.selectedtags).map(tag => { return { text: tag.name } });
                } else {
                    return JSON.parse(this.selectedtags).map(tag => { return { text: tag.name_en } });
                }

            },

        },

        methods: {

            toggleDataIsVisible() {
                // this.dataIsVisible = !this.dataIsVisible;
                Event.fire('toggleHelpersVisible');
            },

            applyFilters() {

                /*alert('"' + this.selectedCountriesArray + '"');*/

                var finalURL = '/' + this.currentlocale + '/category/' + this.categoryid + '/' + this.titlees + '/' + this.titleen + '/' + this.selectedSubCategories;

                if(Array.isArray(this.selectedCountriesArray) && this.selectedCountriesArray.length) {

                    /*alert('It is NOT empty');*/

                    let tmpArray = [];

                    this.selectedCountriesArray.forEach(data => {
                        tmpArray.push(data.id)
                    })

                    finalURL += '/' + tmpArray.join();

                } else {
                    /*alert('It IS empty');*/
                    finalURL += '/none';
                    /*alert('So far: ' + finalURL);*/
                }

                if(Array.isArray(this.selectedCorrespondentsArray) && this.selectedCorrespondentsArray.length) {

                    let tmpArray = [];

                    this.selectedCorrespondentsArray.forEach(data => {
                        tmpArray.push(data.id)
                    })

                    finalURL += '/' + tmpArray.join();

                } else {
                    finalURL += '/none';
                }

                if(Array.isArray(this.selectedTags) && this.selectedTags.length) {

                    let tmpArray = [];

                    this.selectedTags.forEach(data => {
                        tmpArray.push(data.text)
                    })

                    finalURL += '/' + tmpArray.join();

                } else {
                    finalURL += '/none';
                }

                window.location = finalURL;
            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            getSubCategories() {

                axios.get('/api/subcategories/' + this.currentlocale)
                    .then(response => {
                        this.subcategories = response.data;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });

            },

            getTags() {

                axios.get('/api/tags/' + this.currentlocale)
                    .then(response => {
                        this.tags = response.data;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });

            },

            getCountries() {

                axios.get('/api/countries/' + this.currentlocale)
                    .then(response => {
                        this.countries = response.data;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });

            },

            getCorrespondents() {

                axios.get('/api/correspondents')
                    .then(response => {
                        this.correspondents = response.data;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });

            },

            countrySelected(value) {
                this.selectedCountriesArray.push(value);
            },

            removeCountryFromSelectedList(index) {
                this.selectedCountriesArray.splice(index, 1)
            },

            correspondentSelected(value) {
                this.selectedCorrespondentsArray.push(value);
            },

            removeCorrespondentFromSelectedList(index) {
                this.selectedCorrespondentsArray.splice(index, 1)
            },

        },

        created() {

            this.getSubCategories();
            this.getCountries();
            this.getCorrespondents();
            this.getTags();

            this.selectedSubCategories = this.incomingSubCategories;
            if(this.selectedcountries !== 'none') this.selectedCountriesArray = this.incomingCountries;
            if(this.selectedcorrespondents !== 'none') this.selectedCorrespondentsArray = this.incomingCorrespondents;
            if(this.selectedtags !== 'none') this.selectedTags = this.incomingTags;

        }

    }

</script>


<style>

.hideHelper {
    height: 0;
    overflow: hidden;
}

.vselect .vs__dropdown-menu {
    max-height: 200px;
}

.ti-autocomplete {
    max-height: 160px;
    overflow: scroll;
}

</style>
